export default __webpack_public_path__ + "static/media/login_pattern2.9403b68c.svg";